import type { OperationDto } from '@/shared/types';

export type MergeOperationsResult = {
  operations: OperationDto[];
  changed: boolean;
};

export const mergeOperations = (
  existing: OperationDto[],
  incoming: OperationDto[]
): MergeOperationsResult => {
  if (!incoming.length) return { operations: existing, changed: false };

  const byId = new Map(
    existing.map(operation => [operation.operaionid, operation])
  );
  let changed = false;

  incoming.forEach(operation => {
    const current = byId.get(operation.operaionid);
    if (!current || current.status !== operation.status) changed = true;
    byId.set(operation.operaionid, operation);
  });

  const operations = Array.from(byId.values()).sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return { operations, changed };
};
